import axios from 'axios';
import React, { Component, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export default function BarrelBlankDetail() {
    const { id } = useParams();
    const [data, setData] = useState({});
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}barrelBlanket/${id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("apEnergyAdminToken")}`
            }
        }).then((res) => {
            if (res && res.data && res.data.success) {
                setData(res.data.data);
            }
        }).catch((err) => {
            console.log(err);
        })
    }, []);
    
    // Calculate barrel diameter from circumference
    const calculateBarrelDiameter = (circumference) => {
        if (circumference && !isNaN(parseFloat(circumference)) && parseFloat(circumference) > 0) {
            return (parseFloat(circumference) / Math.PI).toFixed(2);
        }
        return 'N/A';
    };

    // Calculate barrel length from widths
    const calculateBarrelLength = (sections) => {
        if (sections && sections.length) {
            let totalLength = 0;
            sections.forEach(section => {
                const width = parseFloat(section.width);
                if (!isNaN(width)) {
                    totalLength += width;
                }
            });
            return totalLength > 0 ? totalLength.toFixed(2) : 'N/A';
        }
        return 'N/A';
    };

    return (
        <>
            <div className='flex flex-col items-center justify-center mt-10 text-center'>
                {
                    Object.keys(data).length !== 0 ?
                        <>
                            <table className='w-[80%] border-2'>
                                <tr>
                                    <th className='border-2'>Date</th>
                                    <td className='border-2'>{new Date(data.date).toLocaleString() || ''}</td>
                                </tr>
                                <tr>
                                    <th className='border-2'>Username</th>
                                    <td className='border-2'>{data.username || ''}</td>
                                </tr>
                                <tr>
                                    <th className='border-2'>Company Name</th>
                                    <td className='border-2'>{data.companyName || ''}</td>
                                </tr>
                                <tr>
                                    <th className='border-2'>Utility</th>
                                    <td className='border-2'>{data.utility || ''}</td>
                                </tr>
                                <tr>
                                    <th className='border-2'>City</th>
                                    <td className='border-2'>{data.city || ''}</td>
                                </tr>
                                <tr>
                                    <th className='border-2'>State</th>
                                    <td className='border-2'>{data.state || ''}</td>
                                </tr>
                                <tr>
                                    <th className='border-2'>Zip Code</th>
                                    <td className='border-2'>{data.zipCode || ''}</td>
                                </tr>
                                <tr>
                                    <th className='border-2'>Facility Operating Hours</th>
                                    <td className='border-2'>{data.facilityOperatingHours || ''}</td>
                                </tr>
                                <tr>
                                    <th className='border-2'>Ambient Temperature</th>
                                    <td className='border-2'>{data.ambientTemperature || ''}</td>
                                </tr>
                            </table>

                            {
                                data.barrelEntries && data.barrelEntries.length ?
                                    <>
                                        <h2 className='mt-10 mb-5 text-xl font-bold'>Barrel Blanket Investigation Entries</h2>
                                        <table className='w-[80%] border-2 mt-5 text-center'>
                                            <thead>
                                                <tr>
                                                    <th className='border-2'>Equipment ID</th>
                                                    <th className='border-2'>Model</th>
                                                    <th className='border-2'>Size (Tons)</th>
                                                    <th className='border-2'>Setpoint Temp (°F)</th>
                                                    <th className='border-2'>Orientation</th>
                                                    <th className='border-2'>Type of Cooling</th>
                                                    <th className='border-2'>Shrouding</th>
                                                    <th className='border-2'>Insulation</th>
                                                    <th className='border-2'>Barrel Diameter (in)</th>
                                                    <th className='border-2'>Barrel Length (in)</th>
                                                    <th className='border-2'>Notes</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    data.barrelEntries.map((entry, idx) => {
                                                        const firstSection = entry.equipmentSectionsSizes && entry.equipmentSectionsSizes.length > 0 
                                                            ? entry.equipmentSectionsSizes[0] 
                                                            : null;
                                                        const barrelDiameter = firstSection 
                                                            ? calculateBarrelDiameter(firstSection.circumference) 
                                                            : 'N/A';
                                                        const barrelLength = calculateBarrelLength(entry.equipmentSectionsSizes);
                                                        
                                                        return (
                                                            <tr key={idx}>
                                                                <td className='border-2'>{entry.equipmentId || 'N/A'}</td>
                                                                <td className='border-2'>{entry.model || 'N/A'}</td>
                                                                <td className='border-2'>{entry.size || 'N/A'}</td>
                                                                <td className='border-2'>{entry.setpointTemp || 'N/A'}</td>
                                                                <td className='border-2'>{entry.orientation || 'N/A'}</td>
                                                                <td className='border-2'>{entry.typeOfCooling || 'N/A'}</td>
                                                                <td className='border-2'>{entry.shrouding ? 'Yes' : 'No'}</td>
                                                                <td className='border-2'>{entry.insulation ? 'Yes' : 'No'}</td>
                                                                <td className='border-2'>{barrelDiameter}</td>
                                                                <td className='border-2'>{barrelLength}</td>
                                                                <td className='border-2'>{entry.notes || 'N/A'}</td>
                                                            </tr>
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        </table>

                                        {/* Equipment Sections Details */}
                                        {data.barrelEntries.map((entry, entryIdx) => (
                                            entry.equipmentSectionsSizes && entry.equipmentSectionsSizes.length > 0 && (
                                                <div key={entryIdx} className='mt-10 w-[80%]'>
                                                    <h3 className='text-lg font-semibold mb-3'>
                                                        Equipment Sections - Entry #{entryIdx + 1} (Equipment ID: {entry.equipmentId || 'N/A'})
                                                    </h3>
                                                    <table className='w-full border-2 text-center'>
                                                        <thead>
                                                            <tr>
                                                                <th className='border-2'>Section</th>
                                                                <th className='border-2'>Circumference (in)</th>
                                                                <th className='border-2'>Width (in)</th>
                                                                <th className='border-2'>Surface Area (in²)</th>
                                                                <th className='border-2'>TB</th>
                                                                <th className='border-2'>Notes</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                entry.equipmentSectionsSizes.map((section, sectionIdx) => (
                                                                    <tr key={sectionIdx}>
                                                                        <td className='border-2'>Section {sectionIdx + 1}</td>
                                                                        <td className='border-2'>{section.circumference || 'N/A'}</td>
                                                                        <td className='border-2'>{section.width || 'N/A'}</td>
                                                                        <td className='border-2'>{section.surfaceArea || '0'}</td>
                                                                        <td className='border-2'>{section.tb || 'No'}</td>
                                                                        <td className='border-2'>{section.notes || 'N/A'}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )
                                        ))}
                                    </>
                                    :
                                    <></>
                            }
                        </>
                        :
                        <>
                        </>
                }
            </div>
        </>
    )
}

